import { useNavigate } from 'react-router-dom';
import { ErrorResponseModal, SuccessResponseModal } from '@/components/AppModal/modals';

/**
 * Custom hook to handle form submission with a mutation.
 * @param {Object} mutation - The mutation object from react-query.
 * @param {Function} payload - Function to format the payload before submission.
 * @param {Object} options - Options for handling success, error, and navigation.
 * @returns {Function} - A function that takes form values and handles submission.
 */

function useFormSubmit(
  mutation,
  payload = (v) => v,
  options = {
    targetPath: '',
    onSuccess: () => {},
    onError: () => {},
    onOk: () => {},
  }
) {
  const { targetPath, onSuccess, onError, onOk } = options;
  const navigate = useNavigate();

  return async (values) => {
    const formatPayload = await payload(values);

    try {
      await mutation.mutateAsync(formatPayload);
      if (onSuccess) {
        onSuccess();
      } else {
        SuccessResponseModal({
          onOk: () => {
            if (onOk) {
              onOk();
            } else {
              navigate(targetPath ? targetPath : -1, {
                replace: true,
              });
            }
          },
        });
      }
    } catch (error) {
      const errorMessage = error?.data?.errorMessage || 'Something went wrong';
      if (onError) {
        onError(errorMessage);
      } else {
        ErrorResponseModal({
          message: errorMessage,
        });
      }
    }
  };
}

export default useFormSubmit;
